import AddEventActions from './AddEventActions';
import HomeScreen from '../screens/HomeScreen';
import MonthScreen from '../screens/MonthScreen';

export default function CalendarScreen({
  currentScreen,
  onScreenshot,
  onManualAdd,
  // HomeScreen props
  currentDay, currentMonth, currentYear,
  todayDay, todayMonth,
  navigateDay, events, setSortOrder,
  isSyncing, syncError, setSyncError,
  openEventDetail, setCurrentScreen,
  swipeHandlers,
  // MonthScreen props
  viewMonth, viewYear, setViewMonth, setViewYear,
  selectedDate, setSelectedDate,
  allEvents,
  todayYear,
}) {
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 overflow-hidden">
        {currentScreen === 'home' && (
          <HomeScreen
            currentDay={currentDay} currentMonth={currentMonth} currentYear={currentYear}
            todayDay={todayDay} todayMonth={todayMonth}
            navigateDay={navigateDay} events={events} setSortOrder={setSortOrder}
            isSyncing={isSyncing} syncError={syncError} setSyncError={setSyncError}
            openEventDetail={openEventDetail} setCurrentScreen={setCurrentScreen}
            swipeHandlers={swipeHandlers}
          />
        )}
        {currentScreen === 'month' && (
          <MonthScreen
            viewMonth={viewMonth} viewYear={viewYear} setViewMonth={setViewMonth} setViewYear={setViewYear}
            selectedDate={selectedDate} setSelectedDate={setSelectedDate}
            allEvents={allEvents} setCurrentScreen={setCurrentScreen}
            openEventDetail={openEventDetail}
            todayDay={todayDay} todayMonth={todayMonth} todayYear={todayYear}
          />
        )}
      </div>
      <div className="shrink-0 bg-white border-t border-gray-100 py-2">
        <AddEventActions
          onScreenshot={onScreenshot}
          onManual={onManualAdd}
          className=""
        />
      </div>
    </div>
  );
}
